import { render } from "./TheWatch.vue?vue&type=template&id=c41bd15e&scoped=true"
import script from "./TheWatch.vue?vue&type=script&lang=js"
export * from "./TheWatch.vue?vue&type=script&lang=js"

import "./TheWatch.vue?vue&type=style&index=0&id=c41bd15e&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c41bd15e"]])

export default __exports__